import { JsonObject } from '@/lib/helpers';
import { get as getLocal, set as setLocal, remove as removeLocal } from '../local-storage';
import { BrandingModel } from '../models/branding.model';
import { AuthProvider } from './auth.service';
import { get } from './sp-api.service';

const BRANDING_CACHE_KEY = 'sp-branding';

const getBrandingByPath = async (path: string): Promise<BrandingModel | null> => {
  const response = await get(`${path}?fields=name,branding`);
  if (!response) {
    return null;
  }

  const {
    _id: id,
    name,
    branding,
  } = (response as { _id: string; name: string; branding: JsonObject }) || {};

  return new BrandingModel({
    ...branding,
    name,
    id,
  });
};

export const getBranding = async (): Promise<BrandingModel | null> => {
  if (AuthProvider.orgId) {
    return getBrandingByPath(`/orgs/${AuthProvider.orgId}`);
  }

  if (AuthProvider.partnerId) {
    return getBrandingByPath(`/partners/${AuthProvider.partnerId}`);
  }

  return null;
};

export const getCachedBranding = (): BrandingModel | null => {
  const brandingJson = getLocal(BRANDING_CACHE_KEY, true) as JsonObject;

  if (!brandingJson) {
    return null;
  }

  return new BrandingModel(brandingJson);
};

export const setCachedBranding = (branding: BrandingModel) => {
  setLocal(BRANDING_CACHE_KEY, branding._json);
};

export const deleteCachedBranding = () => {
  removeLocal(BRANDING_CACHE_KEY);
};
